module.exports = __webpack_public_path__ + "static/img/smartProduct12.ab81b60a.png";